import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Typography from '@material-ui/core/Typography';
import AddressForm from './AddressForm.js';
import PaymentForm from './PaymentForm.js';
import Review from './Review.js';
import Start from './Start.js';
import General from './General.js';
import Detalle from './DetalleComprobante.js';
import Resumen from './ResumenComprobante.js';
import Dashboard from './Dashboard.js';
import ReferenceDocs from './ReferenceDocs.js';
import cx from 'clsx';
import { useOverShadowStyles } from '@mui-treasury/styles/shadow/over';
import Spinner from '@material-ui/core/CircularProgress';

import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import { Collapse } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { isExpired, decodeToken } from "react-jwt";
import {
    Card, CardHeader, CardImg, CardText, CardBody,
    CardTitle, CardSubtitle, Row, Col, Button, Form, FormGroup
} from 'reactstrap';
import { unregister } from "../Interceptor.js";


function Copyright() {
    return (
        <p style={{ color: 'white', marginTop: "-30px" }}>
            eBill Facturación Electrónica, 2020
        </p>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: "30px",
        borderRadius: 12,
        padding: 30,
       fontFamily: 'Hammersmith One'
    },
    appBar: {
        position: 'relative',
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
            width: 1000,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(3),
        borderRadius: 12,
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },

    },
    stepper: {
        padding: theme.spacing(3, 0, 5),
        fontFamily: 'Hammersmith One'
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
}));

const steps = ['Empleado', 'Información General', 'Detalle', 'Resumen'];

function getStepContent(step) {
    switch (step) {
        case 0:
            return <Start />
        case 1:
            return <General />;
        case 2:
            return <Detalle />;
        case 3:
            return <Resumen />;
        default:
            throw new Error('Unknown step');
    }
}

var message = "";

export default function Checkout(props) {

    

    const [loading, setLoading] = React.useState(false);
    const [open, setOpen] = React.useState(true);

    const selectDataLoad = () => {
        /*var token = localStorage.getItem('token');
        var isMyTokenExpired = isExpired(token);
        var token = localStorage.setItem("tokenValidate", isMyTokenExpired);
        
        if (isMyTokenExpired) {
            window.location = "/"
        }*/
        setLoading(true);
        var myHeaders = new Headers();
        var tipoComprobante = localStorage.getItem('tipoComprobante');
        var nombreVendedor = localStorage.getItem('nombreVendedor');
        var formaPago = localStorage.getItem('formaPago');
        var medioPago = localStorage.getItem('medioPago');
        var moneda = localStorage.getItem('moneda');

        var fechaPago = localStorage.getItem('fechaPago');
        var fechaExpedicion = localStorage.getItem('fechaExpedicion');
        var fechaVencimiento = localStorage.getItem('fechaVencimiento');

        var productosdetalle = localStorage.getItem('productos');
        var productos = JSON.parse(productosdetalle);

        for (var i = 0; i < productos.length; i++) {
            productos[i].IdConcepto = i + 1;
            productos[i].ItemReferencia = i + 1;
            productos[i].CodigosString = productos[i].CodigoProducto;
            
            productos[i].CON_dato_decimal1 = productos[i].Cantidad * productos[i].ValorUnitario;
            if (productos[i].TipoImpuesto === "2") {
                productos[i].IVAProducto = 0;
                productos[i].PorIVAProducto = 0;
                productos[i].TipoImpuesto = 0;
            } else {
                productos[i].IVAProducto = ((productos[i].ValorUnitario * productos[i].Cantidad) * (productos[i].PorIVAProducto) / 100);

                if (productos[i].TipoImpuesto === "0" || productos[i].TipoImpuesto === 0) {
                    productos[i].TipoImpuesto = 1;
                } else {
                    productos[i].TipoImpuesto = 4;

                }
            }


        }

        

        var lineas = localStorage.getItem('totalLineas');
        var subtotal = localStorage.getItem('subtotal');
        var totalIva = localStorage.getItem('totalIVA');
        var totalInc = localStorage.getItem('totalINC');
        var bcd = localStorage.getItem('BCD');
        var bcdi = localStorage.getItem('BCDI');
        var totalpagar = localStorage.getItem('totalPagar');

        var observaciones = localStorage.getItem('observaciones') ?? "";
        var idInterno = localStorage.getItem('clienteDefault');

        var prefijoref = localStorage.getItem('prefijoReferencia')
        var numeroref = localStorage.getItem('numeroReferencia')
        var cdfref = "[" + prefijoref + "-" + numeroref + "]"

        var prefijofac = "";
        var numerofac = 0;
        var numeracionAuto = localStorage.getItem('numeracionAuto');
        if (numeracionAuto === "true") {
            prefijofac = "";
            numerofac = 0;
            
        } else {

            prefijofac = localStorage.getItem('prefijoFacNumeracion');
            numerofac = parseInt(localStorage.getItem('numeroFacNumeracion'));
            
            
        }

        var raw = {}

        if (moneda != "COP") {

            var tasa = localStorage.getItem('Tasa');
            var fechatasa = localStorage.getItem('fechaPagoTasa');

            raw = {
                FV_CFDCab: {
                    TipoComprobante: tipoComprobante,
                    Prefijo: prefijofac,
                    NumFactura: numerofac,
                    IDInterno: idInterno, //Id del Cliente
                    NombreVendedor: nombreVendedor,
                    OrderID: localStorage.getItem('numeroOrden'),
                    FormaPago: formaPago,
                    Condiciones_Pago: medioPago,
                    MonedaISO: moneda,
                    pague_hasta3: fechaPago,
                    FechaExpedicion: fechaExpedicion,
                    FechaVencimiento: fechaVencimiento,
                    NumAprobacionRes: localStorage.getItem('resolucionDefault'), //"123456",Get resoluciones
                    AnoAprobacionRes: localStorage.getItem('resolucionAnio'), //2019 Ajustar el get de Wendy de las resoluciones
                    CFD_LineCountNumeric: lineas,
                    CFD_LineExtensionAmount: subtotal,//Sale del subtotal
                    TotalIVA: totalIva, //se calcula o se toma de la pantalla
                    CFD_base_impo_total_nal: totalInc,
                    CFD_TaxExclusiveAmount: bcd,//Base + Cargos - Descuentos
                    CFD_TaxInclusiveAmount: bcdi,//Base + Cargos - Descuentos+Impuestos
                    Total_a_Pagar: totalpagar, //Se toma de la pantalla
                    InfoAdicional: observaciones, //Observaciones  
                    CFD_ResponseCode: localStorage.getItem('tipoCorreccion'),
                    FV_TDO_Codigo_TipoOperacion: localStorage.getItem('tipoFactura'),
                    referencia: cdfref,
                    CFD_campo_texto_15: localStorage.getItem('cufeReferencia'),
                    pague_hasta1: localStorage.getItem('fechaReferencia'),
                    TasaCambio: tasa,
                    CFD_fecha_tasadeCambio: fechatasa
                },

                FV_CFDDet: productos
            };
        } else {
            raw = {
                FV_CFDCab: {
                    TipoComprobante: tipoComprobante,
                    Prefijo: prefijofac,
                    NumFactura: numerofac,
                    IDInterno: idInterno, //Id del Cliente
                    NombreVendedor: nombreVendedor,
                    OrderID: localStorage.getItem('numeroOrden'),
                    FormaPago: formaPago,
                    Condiciones_Pago: medioPago,
                    MonedaISO: moneda,
                    pague_hasta3: fechaPago,
                    FechaExpedicion: fechaExpedicion,
                    FechaVencimiento: fechaVencimiento,
                    NumAprobacionRes: localStorage.getItem('resolucionDefault'), //"123456",Get resoluciones
                    AnoAprobacionRes: localStorage.getItem('resolucionAnio'), //2019 Ajustar el get de Wendy de las resoluciones
                    CFD_LineCountNumeric: lineas,
                    CFD_LineExtensionAmount: subtotal,//Sale del subtotal
                    TotalIVA: totalIva, //se calcula o se toma de la pantalla
                    CFD_base_impo_total_nal: totalInc,
                    CFD_TaxExclusiveAmount: bcd,//Base + Cargos - Descuentos
                    CFD_TaxInclusiveAmount: bcdi,//Base + Cargos - Descuentos+Impuestos
                    Total_a_Pagar: totalpagar, //Se toma de la pantalla
                    InfoAdicional: observaciones, //Observaciones  
                    CFD_ResponseCode: localStorage.getItem('tipoCorreccion'),
                    FV_TDO_Codigo_TipoOperacion: localStorage.getItem('tipoFactura'),
                    referencia: cdfref,
                    CFD_campo_texto_15: localStorage.getItem('cufeReferencia'),
                    pague_hasta1: localStorage.getItem('fechaReferencia')
                },

                FV_CFDDet: productos
            };
        }

        

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(raw),
            redirect: 'follow'
        };

        fetch("./api/Documento/CreateBilling ", requestOptions)
            .then(some => some.json())
            .then(result => {
                
                message = String(result.messageResponse);
                setMessage(message);
                
                setLoading(false);
                handleNext();
                localStorage.removeItem('nombreVendedor');
                localStorage.removeItem('numeroOrden');
                localStorage.removeItem('prefijoFacNumeracion');
                localStorage.removeItem('numeroFacNumeracion');
                localStorage.setItem('observaciones', " ");
            })
            .catch(error => console.log('error', error));
    }

    const [messageSucc, setMessage] = React.useState(message);
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const shadowStyles = useOverShadowStyles({ inactive: true });

    const handleNext = () => {
        setActiveStep(activeStep + 1);
    };

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    const nuevaFactura = () => {
        window.location.reload(false);
    };

    var detalle = [];
    var empleado = {};
    var total = 0;

    const getDetalle = (idEmpleado) => {

        var myHeaders = new Headers();
        var token = localStorage.getItem('token');
        var isMyTokenExpired = isExpired(token);
        var token = localStorage.setItem("tokenValidate", isMyTokenExpired);

        
        if (isMyTokenExpired) {
            window.location = "/"
        }

        
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        let periodomes = localStorage.getItem("mes");
        let periodoano = localStorage.getItem("anio");

        var url = "./api/Novedad/TraerNovedadxEmpleado?iIdEmpleado=" + idEmpleado + "&shMes=" + periodomes + "&iAno=" + periodoano;
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                var novedades = result.basePresentationList;
                //setNovedades(result.basePresentationList);
                for (var i = 0; i < novedades.length; i++) {
                    var nov = {
                        "Cantidad": novedades[i].Cantidad,
                        "CodigoProducto": novedades[i].ProductoRef,
                        "DescripcionProducto": novedades[i].ProductoNombre,
                        "PorImpuesto2": novedades[i].PorcentajeImpto,
                        "ValorUnitario": novedades[i].ValorUnitario,
                       
                    }
                    detalle[i] = nov;
                    
                }

                getDetalleEmpleado(idEmpleado);
            })
            .catch(error => console.log('error', error));
    }

    const getDetalleEmpleado = (idEmpleado) => {
        console.log("creandp nomina get detalle empleado");
        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        console.log(idEmpleado);
        var url = "./api/Empleado/TraerEmpleado?iIdEmpleado=" + idEmpleado;
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                empleado = result.basePresentation;
                console.log("llamando nomina");
                nomina();   
            })
            .catch(error => ('error', error));
    }

    const crearnomina = () => {
        console.log("creandp nomina1");
        var idEmpleado = localStorage.getItem("idEmpleado");
        getDetalle(idEmpleado);
    }

    const grabareBill = () => {
        activeStep === steps.length ? crearnomina : handleNext
        activeStep === steps.length - 1 ? 'Crear Comprobante' : 'Siguiente'
    }

    const nomina = () => {
        console.log("creando nomina");
        var myHeaders = new Headers();

        var date = new Date();
        var month = '' + (date.getMonth() + 1);
        var day = '' + date.getDate();
        var year = date.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        var dateformatted = [year, month, day].join('-');

        

        let numfact = localStorage.getItem("NumeroComprobante")
        console.log(localStorage.getItem("NumeroComprobante"));
        console.log(localStorage.getItem("consecutivoComprobante"));
        console.log(localStorage.getItem("numeroFacNumeracion"));
        console.log(localStorage.getItem("prefijoFacNumeracion"));
        
        console.log(empleado);


        var raw = JSON.stringify({
            "NOM_CFDCab": {
                "TipoComprobante": localStorage.getItem("tipoComprobante"),
                "AnoAprobacionRes": date.getFullYear(),
                "CFD_TaxPointDate": dateformatted,
                "CFD_campo_texto_12": empleado.NombreBanco,
                "CFD_campo_texto_14": empleado.NumeroCuenta,
                "CFD_campo_texto_17": empleado.TipoCuenta,
                "CFD_campo_texto_18": empleado.SegundoApellido ?? " ",
                "CFD_campo_texto_21": "2",
                "CFD_campo_texto_22": "2021-06-30",
                "CFD_campo_texto_23": String(empleado.SalarioIntegral),
                "CFD_cantidad_dec_20": empleado.TiempoLaborado,
                "CFD_numero_enlace_doc_ref": (localStorage.getItem("NumeroComprobante") != null) ? localStorage.getItem("NumeroComprobante")  + localStorage.getItem("consecutivoComprobante") : "",
                "CFD_total_cargos": localStorage.getItem("totalDef") ?? 0,
                "CFD_total_descuentos": localStorage.getItem("totalDef") ?? 0,
                "CampoTexto1": "5",
                "CampoTexto2": "56",
                "CampoTexto3": "00",
                "CampoTexto4": "false",
                "CampoTexto5":  empleado.PrimerApellido,
                "CantidadDec2": 1800000,
                "FechaExpedicion": dateformatted,
                "FechaInicialPeriodoFacturado": "2021-11-08",
                "FechaVencimiento": "2021-11-30",
                "FormaPago": "1",
                "IDInterno": empleado.Id,
                "InfoAdicional": "Nomina Electrónica",
                "MonedaISO": localStorage.getItem("moneda"),
                "NumAprobacionRes": "123456789",
                "NumFactura": localStorage.getItem("NumeroComprobante"),
                "PAI_nombre_envio": empleado.PaisIso,
                    //empleado.Pais,
                "Prefijo": localStorage.getItem("consecutivoComprobante"),
                "TasaCambio": localStorage.getItem("tasaCambio") ?? 0,
                "Texto3": empleado.PrimerNombre + " " + empleado.SegundoNombre,
                "TipoComprobante": 34,
                "Total_a_Pagar": localStorage.getItem("totalDef") ?? 0,
                "ciudad_envio": empleado.MunicipioDane ?? "11011",
                "departamento_envio": empleado.DepartamentoDane ?? "11",
                "direccion_envio": empleado.DireccionEmpleado ?? "Sin Direccion" ,
                "pague_hasta1": dateformatted,
                "pague_hasta2": dateformatted,
                "Condiciones_Pago": "14"
            },
            "NOM_CFDDet": detalle
            //"CFD_numero_enlace_doc_ref": localStorage.getItem("NumeroComprobante") ?? "" + localStorage.setItem("consecutivoComprobante"),
        });

        
        console.log(raw);
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        setLoading(true);

        fetch("./api/Nomina/ProcesarComprobanteNomina", requestOptions)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            message = String(result.messageResponse);
            setMessage(message);
            handleNext();
            setLoading(false);
        })
        .catch(error => console.log('error', error));
    }

    const toHome = () => {
        window.location = "/admin/notifications";
    }

    return (
        
            <div className="content">
                <Row>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <Row>
                                    <Col sm={6}>
                                        <h3 className="title" style={{ fontFamily: 'Hammersmith One', marginLeft: "15px", marginTop: "10px" }}>Crear Nomina</h3>

                                    </Col>
                                </Row>

                            </CardHeader>
                            <CardBody className="all-icons" style={{ margin: "40px", marginTop: "-40px", fontFamily: 'Hammersmith One' }}>
                                <React.Fragment>

                                    <Stepper activeStep={activeStep} className={classes.stepper} style={{ fontFamily: 'Hammersmith One'}}>
                                        {steps.map((label) => (
                                            <Step style={{ fontFamily: 'Hammersmith One' }} key={label}>
                                                <StepLabel style={{ fontFamily: 'Hammersmith One' }} >{label}</StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>
                                    <React.Fragment>
                                        {activeStep === steps.length ? (
                                            <React.Fragment>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} md={12}>
                                                        <Collapse in={open}>
                                                            <Alert severity="success" onClose={() => { }}>
                                                                <AlertTitle>Resultado de la operación.</AlertTitle>
                                                                {messageSucc}
                                                            </Alert>
                                                        </Collapse>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} md={5}>

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={toHome}
                                                            >Ver Documentos
                                                 </Button>
                                                        
                                                        <Button
                                                            variant="contained"
                                                            color="secondary"
                                                            style={{ margin: "5px" }}
                                                            onClick={nuevaFactura}
                                                        >Nuevo Documento
                                                 </Button>

                                                    </Grid>
                                                    <Grid item xs={12} md={3}>



                                                    </Grid>
                                                </Grid>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>

                                                <Dialog open={loading} >
                                                    <div style={{ textAlign: "center", margin: "15px" }}>
                                                        {loading && <Spinner color="secondary" />}
                                                        <h3 style={{ fontSize: '15px', fontFamily: 'Hammersmith One' }}>Cargando...</h3>
                                                    </div>
                                                </Dialog>

                                                    {getStepContent(activeStep)}
                                                    <div className={classes.buttons}>
                                                        {activeStep !== 0 && (
                                                            <Button onClick={handleBack} className={classes.button}>
                                                                Anterior
                                                            </Button>
                                                    )}
                                                    {/*
                                                    <Button onClick={grabareBill} className={classes.button}>
                                                        Crear Comprobante
                                                    </Button>
                                                     */}
                                                            
                                                    <Button style={{ fontFamily: 'Hammersmith One' }} className={classes.button}

                                                        onClick={activeStep === steps.length - 1 ? crearnomina : handleNext}>
                                                        {activeStep === steps.length - 1 ? 'Crear Comprobante' : 'Siguiente'}
                                                        </Button>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                    </React.Fragment>
                                </React.Fragment>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                
            </div>
            
    );
}
